import { useState } from "react";
import { useTranslation } from "react-i18next";
import ClickIcon from "../../../../components/essentials/icon-buttons/click-icon/ClickIcon";
import { NewMessageModal } from "../../Messages";
import "./MessagesHeader.scss";

const MessagesHeader: React.FC = () => {
	const { t } = useTranslation();
	const [isModalOpen, setModalOpen] = useState<boolean>(false);
	return (
		<>
			<div className="chats-title">
				<p>{t("messages.chatsTitle")}</p>

				<ClickIcon
					className="chats-new"
					icon="edit"
					size="s"
					onClick={() => setModalOpen(true)}
					color="black"
				/>
				{isModalOpen && (
					<NewMessageModal
						isModalOpen={isModalOpen}
						setModalOpen={setModalOpen}
					/>
				)}
			</div>
			{/* <div className="search-message">
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  return (
    <>
      <div className="chats-title">
        <p>{t("messages.chatsTitle")}</p>
        <ClickIcon
          className="chats-new"
          icon="edit"
          size="s"
          onClick={() => setModalOpen(true)}
          color="black"
        />
        {isModalOpen && (
          <NewMessageModal
            isModalOpen={isModalOpen}
            setModalOpen={setModalOpen}
          />
        )}
      </div>
      <div className="search-message">
        <Search />
        <div className="input-msg">
          <AcedTooltip text={t("messages.searchWip")}>
            <input name="search" placeholder={t("messages.searchPlaceholder")} disabled />
          </AcedTooltip>
        </div>
      </div> */}
		</>
	);
};

export default MessagesHeader;
